import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { http } from 'wagmi'
import { mainnet, sepolia } from 'wagmi/chains'

import { getContractConfig, isEnvProduction } from '../../util/app.helpers'
import { abi } from '../../abis/abi'

const isEnvProd = isEnvProduction()
const chains = [mainnet, sepolia]
const transports = isEnvProd
  ? {
      [mainnet.id]: http()
    }
  : {
      [sepolia.id]: http()
    }

const wagmiConfig = getDefaultConfig({
  appName: `qbx${!isEnvProd ? '-testing' : ''}`,
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  chains,
  transports,
  batch: { multicall: true },
  ssr: false
})

const getChain = () => {
  return isEnvProd ? mainnet : sepolia
}

const contractAddress = getContractConfig().address

const wagmiContractConfig = {
  address: contractAddress,
  abi
}

export { wagmiConfig, getChain, contractAddress, wagmiContractConfig }
